theme = theme || {};
theme.currencyConverter = function(mode, oldCurrency, newCurrency, selector, format){
  if(mode == 'select'){
    Currency.convertAll(oldCurrency, newCurrency, selector, format);
  } else {
    var cookieCurrency = Currency.cookie.read() || theme.shopCurrency;
    var currencySelectorVal = jQuery(document).find(theme.currencySelector).attr('data-currency');
    var newCurrencySymbol = jQuery(document).find('.form-field-select a[data-value="'+cookieCurrency+'"]').data('symbol') || cookieCurrency;
    var notConvertedYet = jQuery(document).find('#relatedProductsSwiper').data('limit') || 0;
    if(cookieCurrency == currencySelectorVal) return;
    //console.log(currencySelectorVal);
    jQuery(document).find(theme.currencySelector).attr('data-currency', cookieCurrency);
    jQuery(document).find(theme.currencySelector).html(newCurrencySymbol+' <i class="lin lin-arrow-down"></i>');
    Currency.convertAll(currencySelectorVal, cookieCurrency, 'span.money', 'money_format');
    var convertAllPrice = setInterval(function(){
      if(notConvertedYet > 0){
        Currency.convertAll(currencySelectorVal, cookieCurrency, 'span.money', 'money_format');
        notConvertedYet -= 1; 
      } else {
        clearInterval(convertAllPrice);
      }
    }, 500);
  }
}
jQuery(function($){

  var swiper = new Swiper('.collection-row-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    // init: false,
    navigation: {
      nextEl: '.swiper-next',
      prevEl: '.swiper-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    }
  });
  
  if( $('#page-header').hasClass('page-header')) {
    $(document.body).addClass('banner-enabled');
  }
  
  //Custom tag filter
  $('.category-filters-area-list').click(function() {
    //$('.category-filters-area-list').toggleClass('open-list');
    $(this).parent().toggleClass("open-list");
    return false;
  });
  
  $('.select-brand').click(function() {
    $('.select-brand').toggleClass('show-brands');
    $(this).next().slideToggle(200);
  });
  
  
  //Product tab
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
  //Product accordion 
  $(".accordion-wrap").each(function(){  
    $(this).find(".accordion -content").hide();
    $(".accordion-content.active").show();
  });

  $(".accordion-wrap").each(function(){
    $(this).find(".accordion-heading").click(function() {
      $('.accordion-heading').removeClass('active').next().slideUp(200); 
      $(this).toggleClass("active").next().stop(true, false).slideToggle(200);      
      return false;
    });
  });

  //Custom tag filter
  $('.ask a').click(function() {
    $('#product-ask-widget').slideToggle(200);
    return false;
  });
  
//   sidebar
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  var collFilters = jQuery('.category-filters-area-list li a');
  collFilters.click(function(e) {
     e.preventDefault();
    delete Shopify.queryParams.page;
    var newTags = [];
	var newURL = $(this).attr('value');
    var title = $(this).attr('title');
    
   // location.href = newURL;
    console.log(newURL);
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass("active");
    var productsContainer = $('.collection-row'); 
  var productsCountContainer = $('.category-product-sorting-total');
     $.get({
        url: newURL,
       success: function (data) { 
         var newProductsCountWrapper = $(data).find(".category-product-sorting-total");
         var newProductsCountHtml = newProductsCountWrapper.html();
         
         var newProductsWrapper = $(data).find(".collection-row");
         var newProductsHtml = newProductsWrapper.html();
         productsContainer.html(newProductsHtml);
         productsCountContainer.html(newProductsCountHtml);
         console.log(data);
         if(title != 'all'){
         $('.brand-filter').hide();
         }else{
         $('.brand-filter').show();
         }
         history.pushState({
           page: newURL
         }, null, newURL);
       }
     })
    
    
    
    
  });  
//   Sidebar end
  
  //product - customer QA widget
  $(document).on('click', 'a[href="#product-ask-widget"]', function(e){
    e.preventDefault();
  	var elementId = $(this).attr('href');
    $(elementId).slideToggle(500);
  });
  
  //change currency
  var $allCurrencies = $(document).find(theme.currencySelector).siblings('ul').find('a');
  theme.currencyConverter();
  $(document).on('click', theme.currencySelector, function(){
    $('body').addClass('currency-switcher-activated');
  });
  $(document).on('click', 'body.currency-switcher-activated', function(){
    $('body').removeClass('currency-switcher-activated');
  });
  $allCurrencies.on('click', function(){
    var oldCurrency = $(document).find(theme.currencySelector).attr('data-currency');
    var newCurrency = $(this).data('value');
    var newCurrencySymbol = $(this).data('symbol') || newCurrency;
    $(document).find(theme.currencySelector).attr('data-currency', newCurrency);
    $(document).find(theme.currencySelector).html(newCurrencySymbol+' <i class="lin lin-arrow-down"></i>');
    theme.currencyConverter('select', oldCurrency, newCurrency, 'span.money', 'money_format');
  });
});